export type Device = 'desktop' | 'mobile';

export function detectDevice(): Device {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent;
  // iOS primary target + Android as fallback
  if (/iPhone|iPad|iPod|Android/i.test(ua)) return 'mobile';
  // small viewport = mobile too
  if (typeof window !== 'undefined' && window.innerWidth < 640) return 'mobile';
  return 'desktop';
}
